import { Expose } from "class-transformer";

export class Auth {
  @Expose({ name: 'access_token' })
  accessToken?: string;
}
